import { useEffect, useState } from 'react';
import { useQuery } from '@tanstack/react-query';
import { api } from '@/api/apiClient';
import { recordId, selectCurrentEvent } from '@/utils/currentEvent';

export function useFeaturedEvent(user) {
  const [now, setNow] = useState(() => new Date());
  useEffect(() => {
    const timer = setInterval(() => setNow(new Date()), 60000);
    return () => clearInterval(timer);
  }, []);
  const options = { staleTime: 60000, refetchInterval: 60000, enabled: Boolean(recordId(user)) };
  const { data: events = [] } = useQuery({ ...options, queryKey: ['events-current', recordId(user)], queryFn: () => api.entities.Event.list() });
  const { data: staffings = [] } = useQuery({ ...options, queryKey: ['staffings-current', recordId(user)], queryFn: () => api.entities.EventStaffing.list() });
  return selectCurrentEvent(events, staffings, user, now);
}
